//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _willChange_organization_person from './willChange_organization_person';
export const willChange_organization_person = _willChange_organization_person;
export default {willChange_organization_person};

